import { getFiscalYear } from 'Store/actions/AdminGoalsActions';
import sortAlphabetically from '../../../../babel/utils/sortAlphabetically';
import QuotaResource from 'Resources/Quota';

angular.module('domain.admin').controller('SalesQuota', [
	'$scope',
	'AppService',
	'RequestBuilder',
	'$safeApply',
	'UserTreeFilterMeta',
	'$q',
	'Report',
	'Order',
	function ($scope, AppService, RequestBuilder, $safeApply, UserTreeFilterMeta, $q, Report, Order) {
		var SalesQuotaCtrl = this;
		var AdminCtrl = $scope.AdminCtrl;

		var isAdmin = AppService.getSelf().administrator;
		var isTeamleader = AppService.getSelf().teamLeader;

		SalesQuotaCtrl.rootData = AdminCtrl.getRootObject();

		SalesQuotaCtrl.rootData.pageComponent = 'salesQuota';

		var metadata = AppService.getMetadata();
		var masterCurrency = _.find(metadata.customerCurrencies, 'masterCurrency');
		var roleCurrencyISO = metadata.role && metadata.role.defaultCurrency;
		var roleCurrency = _.find(metadata.customerCurrencies, { iso: roleCurrencyISO });
		var defaultCurrency = roleCurrency || masterCurrency;

		function getStartAndEndDate(year) {
			var metadata = AppService.getMetadata();

			if (metadata.params.brokenFiscalYearEnabled) {
				var fiscalMoment = window.momentHelper.momentFiscalYear();

				return {
					start: fiscalMoment().startOf('fiscalYear').fiscalYear(year),
					end: fiscalMoment().endOf('fiscalYear').fiscalYear(year)
				};
			} else {
				return {
					start: moment(year, 'YYYY'),
					end: moment(year, 'YYYY').endOf('year')
				};
			}
		}

		SalesQuotaCtrl.rootData.pageLoading = true;
		SalesQuotaCtrl.rootData.pageData = {
			quotas: [],
			year: getFiscalYear(),
			quotaType: 'value',
			user: null,
			tableLoading: true,
			showPreviousYear: false,
			showInactiveUsers: false,
			currencies: metadata.customerCurrencies,
			defaultCurrency: defaultCurrency,
			showCurrency: true,
			masterCurrency: masterCurrency,
			totalTitle: Tools.$translate('salesboard.quota'),
			resultTitle: Tools.$translate('default.sales')
		};

		SalesQuotaCtrl.rootData.updateQuota = function (quota) {
			if (!Array.isArray(quota)) {
				quota = [quota];
			}

			_.each(quota, function (quota) {
				var userQuota = SalesQuotaCtrl.rootData.pageData.userQuotas.find(function (userQuota) {
					return userQuota.user.id === quota.user.id;
				});

				var index = _.findIndex(
					userQuota.quotas,
					oldQuota => oldQuota.month === quota.month && oldQuota.year === quota.year
				);
				if (index > -1) {
					userQuota.quotas[index] = quota;
				}
			});
			QuotaResource.save(quota, { skipNotification: true });
			$safeApply($scope);
		};

		SalesQuotaCtrl.rootData.filterChange = function (filter, value) {
			SalesQuotaCtrl.rootData.pageData[filter] = value;
			SalesQuotaCtrl.rootData.pageData.tableLoading = true;
			$safeApply($scope);

			// eslint-disable-next-line promise/catch-or-return
			getData().then(function () {
				SalesQuotaCtrl.rootData.pageData.tableLoading = false;
			});
		};

		function getData() {
			var filters = new RequestBuilder();
			var quotaDates = getStartAndEndDate(SalesQuotaCtrl.rootData.pageData.year);

			filters.addFilter(
				QuotaResource.attr.date,
				filters.comparisonTypes.GreaterThanEquals,
				/**
				 * We send only the date part of the start date, so wherever you are in the world, you will get the corret config
				 * Users outside the Swedish timezone will not get the goals if we don't send the date part only.
				 * See LINE-8390
				 */
				quotaDates.start.format('YYYY-MM-DD')
			);
			filters.addFilter(
				QuotaResource.attr.date,
				filters.comparisonTypes.LessThanEquals,
				quotaDates.end.toISOString()
			);

			if (SalesQuotaCtrl.rootData.pageData.user) {
				if (SalesQuotaCtrl.rootData.pageData.user.isRole) {
					var roleIds = window.BabelServices.getAllSubRoleIds(SalesQuotaCtrl.rootData.pageData.user.id);
					filters.addFilter(
						QuotaResource.attr.user.attr.role.attr.id,
						filters.comparisonTypes.Equals,
						roleIds
					);
				} else {
					filters.addFilter(
						QuotaResource.attr.user.attr.id,
						filters.comparisonTypes.Equals,
						SalesQuotaCtrl.rootData.pageData.user.id
					);
				}
			}

			var showPreviousYear = SalesQuotaCtrl.rootData.pageData.showPreviousYear;

			var reportFilters = new RequestBuilder();
			if (showPreviousYear) {
				var prevYearsDates = getStartAndEndDate(SalesQuotaCtrl.rootData.pageData.year - 1);
				reportFilters.addFilter(
					Order.attr.date,
					reportFilters.comparisonTypes.GreaterThanEquals,
					prevYearsDates.start.toISOString()
				);
				reportFilters.addFilter(
					Order.attr.date,
					reportFilters.comparisonTypes.LessThanEquals,
					prevYearsDates.end.toISOString()
				);
				reportFilters.addFilter(Order.attr.probability, reportFilters.comparisonTypes.Equals, 100);

				if (SalesQuotaCtrl.rootData.pageData.user) {
					if (SalesQuotaCtrl.rootData.pageData.user.isRole) {
						reportFilters.addFilter(
							Order.attr.user.attr.role.attr.id,
							reportFilters.comparisonTypes.Equals,
							SalesQuotaCtrl.rootData.pageData.user.id
						);
					} else {
						reportFilters.addFilter(
							Order.attr.user.attr.id,
							reportFilters.comparisonTypes.Equals,
							SalesQuotaCtrl.rootData.pageData.user.id
						);
					}
				}

				var agg = reportFilters.aggregationBuilder();
				agg.aggregationName('user');
				agg.addAggregation(reportFilters.aggregationTypes.Terms, Order.attr.user.attr.id);
				agg.aggregationSize(1000);
				var sub = agg.aggregationBuilder();
				sub.aggregationName('date');
				sub.addAggregation(reportFilters.aggregationTypes.Terms, Order.attr.date);
				sub.aggregationInterval(reportFilters.aggregationIntervals.MONTH);
				var subSum = sub.aggregationBuilder();
				subSum.addAggregation(reportFilters.aggregationTypes.Sum, Order.attr.valueInMasterCurrency);
				subSum.aggregationName('value');
				subSum.done();
				sub.done();
				agg.done();
			}

			return $q
				.all({
					quotas: window.fetchAll(QuotaResource, filters),
					previous: showPreviousYear
						? Report.customer(AppService.getCustomerId()).setType('order').find(reportFilters.build())
						: $q.when(),
					roleTree: SalesQuotaCtrl.rootData.pageData.loadUserTree()
				})
				.then(function (res) {
					var users;
					if (SalesQuotaCtrl.rootData.pageData.showInactiveUsers) {
						users = [
							...AppService.getRealActiveUsers(),
							...AppService.getUsers('inactive'),
							...AppService.getUsers('deleted')
						];
					} else {
						users = AppService.getRealActiveUsers();
					}

					users = users.sort(sortAlphabetically('name'));

					if (SalesQuotaCtrl.rootData.pageData.user) {
						if (SalesQuotaCtrl.rootData.pageData.user.isRole) {
							users = window.quotaHelper.findRoleUsers(SalesQuotaCtrl.rootData.pageData.user, users);

							if (!SalesQuotaCtrl.rootData.pageData.showInactiveUsers) {
								users = users.filter(user => !user.ghost);
							}
						} else {
							users = _.filter(users, { id: SalesQuotaCtrl.rootData.pageData.user.id });
						}
					}

					var previousResultByUser = {};
					if (showPreviousYear) {
						previousResultByUser = _.reduce(
							users,
							function (result, user) {
								var userPreviousResult = _.find(res.previous.data.user.buckets, function (bucket) {
									return bucket.key === user.id;
								});

								// moment objects aint immutable remember remember
								var start = moment(prevYearsDates.start);

								var previousResult = _.times(12, function () {
									var month = start.month() + 1;
									var year = start.year();
									start.add(1, 'month');

									if (!userPreviousResult) {
										return 0;
									}

									var previous = _.find(userPreviousResult.date.buckets, function (bucket) {
										return bucket.key_as_string === year + '-' + (month < 10 ? '0' + month : month);
									});

									if (previous && previous.value && previous.value.value) {
										return Math.round(previous.value.value * 100) / 100;
									}
									return 0;
								});

								result[user.id] = previousResult;

								return result;
							},
							{}
						);
					}

					var quotaUserMap = _.reduce(
						res.quotas.data,
						function (result, quota) {
							if (!quota.user) {
								return result;
							}
							if (!result[quota.user.id]) {
								result[quota.user.id] = [];
							}
							result[quota.user.id].push(quota);

							return result;
						},
						{}
					);

					var userIdsInAndUnderTeamLeaderRole = SalesQuotaCtrl.rootData.pageData.roleTree[0]
						? _.map(
								window.quotaHelper.findUsersInTreeRole(SalesQuotaCtrl.rootData.pageData.roleTree[0]),
								'id'
						  )
						: [];

					SalesQuotaCtrl.rootData.pageData.userQuotas = _.reduce(
						users,
						function (result, user) {
							if (!isAdmin && isTeamleader && _.indexOf(userIdsInAndUnderTeamLeaderRole, user.id) < 0) {
								return result;
							}
							var userQuotasByMonth = _.reduce(
								quotaUserMap[user.id],
								function (result, quota) {
									result[quota.month] = quota;
									return result;
								},
								{}
							);

							var start = getStartAndEndDate(SalesQuotaCtrl.rootData.pageData.year).start;

							var allUserQuotas = _.times(12, function () {
								var month = start.month() + 1;
								var year = start.year();
								start.add(1, 'month');

								if (!userQuotasByMonth[month]) {
									var newQuota = QuotaResource.new();
									newQuota.month = month;
									newQuota.year = year;
									newQuota.user = user;
									return newQuota;
								}
								return userQuotasByMonth[month];
							});

							return result.concat({
								user: user,
								quotas: allUserQuotas,
								previous: previousResultByUser[user.id]
							});
						},
						[]
					);
				});
		}

		SalesQuotaCtrl.rootData.pageData.loadUserTree = function () {
			return UserTreeFilterMeta(undefined, true, true, SalesQuotaCtrl.rootData.pageData.showInactiveUsers).then(
				function (roleTree) {
					SalesQuotaCtrl.rootData.pageData.roleTree = roleTree.data;
					if (!isAdmin && isTeamleader) {
						var teamLeaderRole = window.quotaHelper.findUserRoleInTree(AppService.getSelf(), roleTree.data);
						SalesQuotaCtrl.rootData.pageData.roleTree = teamLeaderRole ? [teamLeaderRole] : [];
					}
				}
			);
		};

		var init = function () {
			// eslint-disable-next-line promise/catch-or-return
			getData().then(function () {
				SalesQuotaCtrl.rootData.pageLoading = false;
				SalesQuotaCtrl.rootData.pageData.tableLoading = false;
			});
		};

		// eslint-disable-next-line promise/catch-or-return
		AppService.loadedPromise.then(init);
	}
]);
